import { Routes } from '@angular/router';
import { HomeDataRoutes } from '@pages/flow-routes/new-quotation/home-data/home-data.routing';
import { AdditionalDataRoutes } from './additional-data/additional-data.routing';
import { ConfirmDataRoutes } from './confirm-data/confirm-data.routing';
import { PolicyDataRoutes } from './policy-data/policy-data.routing';
import { PolicyHolderDataRoutes } from './policy-holder-data/policy-holder-data.routing';

export const NewQuotation: Routes = [
  ...HomeDataRoutes,
  ...PolicyDataRoutes,
  ...PolicyHolderDataRoutes,
  ...AdditionalDataRoutes,
  ...ConfirmDataRoutes,
];
